<script setup lang="ts">
const { t } = useI18n();

defineProps({
  value: {
    type: Number,
    required: true
  }
});
</script>
<template>
  <div class="card">
    <div class="card-body">
      <div>
        <div class="fs-4 fw-semibold">
          <FormattedQueueDuration :duration="value" />
        </div>
        <div>{{ t("components.queue_duration.text") }}</div>
      </div>
    </div>
  </div>
</template>
